import dayjs from "dayjs";
import { PassportExpiry } from "./pages/MyProfile";
import { BOOKING_STATUS } from "./config/Constants";
import { airports } from "./config/airports";

export const getParentPath = (path) => {
  let pathObj = {
    dashboard: "dashboard",
    bookings: "bookings",
    business: "business",
    "flight-listing": "dashboard",
    "confirm-flights": "dashboard",
    status: "bookings",
    profile: "profile",
    entitlements: "entitlements",
    confirmRequest: "dashboard",
    pin: "pin",
  };
  return pathObj[path];
};

export const getInitials = (name) => {
  if (!name) return "";

  const nameArray = name.split(" ").slice(0, 2); // Split name and take first two words
  let initials = nameArray.map((word) => word[0]?.toUpperCase()).join(""); // Get the first letter of each word and join them

  return initials;
};

export const getMaskedPhone = (phone) => {
  if (phone) {
    const length = phone.length;
    const lastTwo = phone.substring(length - 2);
    let countNum = "X";
    for (var i = length - 3; i > 0; i--) {
      countNum += "X";
    }
    return countNum + lastTwo;
  } else return "";
};

export const getFormattedDate = (date, dateFormat) => {
  return dayjs(date).format(dateFormat);
};

export const getFormattedBookingList = (data) => {
  console.log("data");
  console.log(data);

  let formattedBookingList = data.map((bookinglist) => {
    let bookingListObj = {
      id: bookinglist?._id,
      name: bookinglist?.membersInfo[0]?.memberName,
      relation: "self", // Need to revisit
      requestID: bookinglist?.requestId,
      requestDate: getFormattedDate(bookinglist?.createdAt, "MMMM DD, YYYY"), //Need to check the key
      departureDate: getFormattedDate(
        bookinglist?.departureDate,
        "MMMM DD, YYYY"
      ),
      returnDate: getFormattedDate(bookinglist?.returnDate, "MMMM DD, YYYY"),
      destination: bookinglist?.to,
      status: bookinglist?.status,
      isBusinessTrip: bookinglist?.isBusinessTrip ? true : false,
      travelDetails: bookinglist?.travelDetails,
    };
    return bookingListObj;
  });
  return formattedBookingList;
};

export const getDestination = (data) => {
  let res = airports.filter((port) => port.iata_code === data)[0];
  return `${res?.city || ""}, ${res?.iata_code || ""}`;
};

export const getFormattedTravelDetails = (data) => {
  let objData = Object.assign({}, data);

  objData.departureDate = getFormattedDate(data.departureDate, "DD MMM YYYY");
  objData.returnDate = getFormattedDate(data.returnDate, "DD MMM YYYY");
  objData.perferAirline = data.perferAirline.join(", ");
  objData.to = getDestination(data.to);

  if (data?.isBusinessTrip) {
    let memInfo = { ...objData?.membersInfo[0] };
    let userInfo = { ...objData?.userInfo };
    memInfo.paymentType = "company paid";
    memInfo.travelType = objData?.businessTripType;
    objData.membersInfo = [{ ...memInfo, 'phone':userInfo?.phone }];
  }

  return objData;
};

export const getFormattedTravellerDetails = (obj) => {
  let newObj = Object.assign({}, obj);
  newObj.passportExpiry = getFormattedDate(obj.passportExpiry, "DD MMM YYYY");
  newObj.relationshipStatus =
    obj.relationshipStatus === "guest"
      ? "Guest"
      : obj.dob
      ? adultOrChild(obj.dob)
      : "";
  return newObj;
};

export const getFormattedDependentsInformation = (data, passportPdfs) => {
  let childIndex = 1;
  function getChildWithIndex() {
    let childWithIndex = `Child${childIndex}`;
    childIndex = childIndex + 1;
    return childWithIndex;
  }
  let formattedDependentsInfo = data?.map((dependentsInfo) => {
    let relationshipString = dependentsInfo?.relationFlag;
    let dependentsInfoObj = {
      firstName: dependentsInfo?.firstName,
      lastName: dependentsInfo?.lastName,
      sponsorshipData: dependentsInfo?.customString2expand,
      relationship: dependentsInfo?.relationFlag,
      passportNumber: dependentsInfo?.passportNumber,
      passportExpirationDate:
        dependentsInfo?.passportExpirationDate &&
        getFormattedDate(dependentsInfo?.passportExpirationDate, "DD MMM YYYY"),
      passportExpiryColor: isExpired(dependentsInfo?.passportExpirationDate)
        ? "#FF0000"
        : "#000000",
      age: dependentsInfo?.age,
      dob:
        dependentsInfo?.dateOfBirth &&
        getFormattedDate(dependentsInfo?.dateOfBirth, "DD MMM YYYY"),
      passportPdf: passportPdfs?.[relationshipString?.toUpperCase()] || "",
    };
    return dependentsInfoObj;
  });
  return formattedDependentsInfo;
};

export const getFormattedPersonalInfo = (data) => {
  let personalInfoObj = {
    "Employee ID": data?.empId,
    "Date of Birth": getFormattedDate(data?.dateOfBirth, "DD MMM YYYY"),
    Age: data?.age,
    Gender: data?.gender === "M" ? "Male" : "Female",
    "Formal Name": data?.formalName,
    "Marital Status": data?.maritalStatus,
    Nationality: data?.territoryName,
    "Nationality Code": data?.nationality,
    "Work Email ID": data?.emailAddress,
    "Personal Email ID": data?.personalEmail,
    "Personal Number": data?.phoneNumber,
    "Work Mobile Number": data?.workPhoneNumber,
    "Passport number": data?.passportNumber,
    "Passport Expiry Date": (
      <PassportExpiry
        color={isExpired(data?.passportExpirationDate) ? "#FF0000" : "#000000"}
      >
        {getFormattedDate(data?.passportExpirationDate, "DD MMM YYYY")}
      </PassportExpiry>
    ),
    "National ID": data?.nationalId,
    "National ID Expiry Date": getFormattedDate(
      data?.nationalIdExpiry,
      "DD MMM YYYY"
    ),
  };
  return personalInfoObj;
};

export const getFormattedJobInfo = (data) => {
  let jobInfoObj = {
    "Job Title": data?.nameOfRole,
    Grade: data?.grade,
    "Employee Group": data?.employeeGroup,
    "Employment Status": data?.employmentStatus,
    "Company Name": getNameAndCode(data.companyName, data.companyCode),
    Cluster: getNameAndCode(data.department, data.departmentCode),
    "Cost Centre": getNameAndCode(data.jobInfoNavCost, data.jobInfoNavCostCode),
  };
  return jobInfoObj;
};

export const truncateText = (str, maxLength) => {
  if (str?.length <= maxLength) {
    return str;
  }
  return str?.substring(0, maxLength) + "...";
};

const getDefaultTravelType = (
  grade,
  cluster,
  categoryType,
  relationshipStatus
) => {
  let gradeLimit =
    cluster === "70001" ? (categoryType === "Support" ? 20 : 19) : 20;
  return grade <= Number(gradeLimit)
    ? "Economy"
    : relationshipStatus === "Self"
    ? "Business Class"
    : "Economy";
};

const getDefaultPaymentType = (ticketCount) => {
  return ticketCount === 0 ? "self paid" : "company paid";
};

export const getFormattedPax = (data, passportData) => {
  let memberInfo = [];

  memberInfo.push({
    empId: data?.empId,
    firstName: data?.firstName,
    lastName: data?.lastName,
    dob: data?.dateOfBirth,
    gender: data?.gender,
    passportNo: data?.passportNumber,
    relationshipStatus: "Self",
    travelType: getDefaultTravelType(
      Number(data?.grade.split("-")[1]),
      data?.departmentCode,
      data?.categoryType,
      "Self"
    ),
    paymentType: getDefaultPaymentType(
      data?.ticketEncash > 0 ? Math.floor(data?.ticketEncash) : 0
    ),
    selected: true,
    passportExpiry: data?.passportExpirationDate,
    privilegeClub: "",
    ticketEncash: data?.ticketEncash > 0 ? Math.floor(data?.ticketEncash) : 0,
    passportPdf: passportData["SELF"],
    employeeGroup: data?.employeeGroup,
    expiryDate:
      Math.floor(data?.ticketEncash) > 0
        ? data?.entitlement?.length > 0
          ? data?.entitlement.reduce((earliest, current) => {
              return new Date(current.expiryDate) <
                new Date(earliest.expiryDate)
                ? current
                : earliest;
            })?.expiryDate
          : ""
        : "",
  });

  let childIndex = 1;
  function getChildWithIndex() {
    let childWithIndex = `Child${childIndex}`;
    childIndex = childIndex + 1;
    return childWithIndex;
  }

  data.personRelationship.map((info) => {
    let memberObject = {
      empId: "",
      firstName: "",
      lastName: "",
      dob: "",
      gender: "",
      passportNo: "",
      relationshipStatus: "",
      travelType: "",
      paymentType: "",
      passportExpiry: "",
      privilegeClub: "",
      ticketEncash: "",
      passportPdf: "",
      sponsorshipData: "",
      expiryDate: "",
    };

    memberObject.empId = data?.empId;
    memberObject.firstName = info?.firstName;
    memberObject.lastName = info?.lastName;
    memberObject.dob = info?.dateOfBirth;
    memberObject.gender = info?.gender;
    memberObject.passportNo = info?.passportNumber || "";
    memberObject.relationshipStatus = info?.relationFlag;
    memberObject.expiryDate =
      Math.floor(info?.ticketEncash) > 0
        ? info?.entitlement?.length > 0
          ? info?.entitlement.reduce((earliest, current) => {
              return new Date(current.expiryDate) <
                new Date(earliest.expiryDate)
                ? current
                : earliest;
            })?.expiryDate
          : ""
        : "";

    memberObject.travelType = getDefaultTravelType(
      Number(data?.grade.split("-")[1]),
      "",
      "",
      info?.relationFlag
    );
    memberObject.paymentType = getDefaultPaymentType(
      info?.ticketEncash > 0 ? Math.floor(info?.ticketEncash) : 0
    );
    memberObject.selected = false;
    memberObject.passportExpiry = info?.passportExpirationDate || "";
    memberObject.privilegeClub = "";
    memberObject.ticketEncash =
      info?.ticketEncash > 0 ? Math.floor(info?.ticketEncash) : 0;
    memberObject.sponsorshipData = info?.customString2expand;
    memberObject.passportPdf =
      passportData[memberObject.relationshipStatus?.toUpperCase()] || "";
    memberInfo.push(memberObject);
  });
  return memberInfo;
};

export const getFormattedDestinationSelectfieldData = (
  data,
  labelKey,
  valueKey,
  placeholderText
) => {
  let formattedData = data.map((item) => {
    let eachObj = { label: "", value: "" };
    eachObj.label = item[labelKey];
    eachObj.value = item[valueKey];
    eachObj.city = item["city"];
    eachObj.country = item["country"];

    return eachObj;
  });

  placeholderText &&
    formattedData.unshift({ label: placeholderText, value: "" });

  return formattedData;
};

export const getAge = (dateString) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const adultOrChild = (dob) => {
  const age = getAge(dob);
  if (age >= 18) return "Adult";
  else return "Child";
};

export const formatReasonDropdown = (data) => {
  let formattedData = data?.map((item) => ({
    label: item?.value,
    value: item?.key,
  }));
  formattedData.unshift({
    label: "Select Reason",
    value: "",
  });
  return formattedData;
};

export const isExpired = (expirydate) => {
  if (expirydate) {
    let today = new Date();
    return new Date(expirydate).getTime() < today;
  }
};

export const getNameAndCode = (cmpName, cmpCode) => {
  let cmpNamePlusCode;
  if (cmpName) {
    cmpNamePlusCode = cmpCode ? cmpName + " (" + cmpCode + ")" : cmpName;
  }
  return cmpNamePlusCode;
};

export const getSapError = (data) => {
  let sapErrorArr = [];

  sapErrorArr = data.map((eachMem, i) => {
    let errorMessage = "";
    // if (
    //   eachMem.passportPdf === "" ||
    //   eachMem.passportExpiry === "" ||
    //   eachMem.passportNo === "" ||
    //   isExpired(eachMem.passportExpiry)
    // ) {
    //   return true;
    // } else return false;
    if (eachMem.relationshipStatus === "Self" && eachMem.passportPdf === "") {
      errorMessage = "Passport Copy";
    }
    if (
      eachMem.relationshipStatus === "Self" &&
      eachMem.passportExpiry === ""
    ) {
      errorMessage =
        errorMessage === ""
          ? "Passsport Expiry"
          : errorMessage + ", Passport Expiry";
    }
    if (eachMem.relationshipStatus === "Self" && eachMem.passportNo === "") {
      errorMessage =
        errorMessage === ""
          ? "Passport number"
          : errorMessage + ", Passport Number";
    }
    if (eachMem.relationshipStatus === "Self" && errorMessage !== "")
      errorMessage =
        errorMessage +
        " not available on SAP. Please raise an Ask HR Ticket and share your passport details to HR for update on SAP. Please proceed with booking after ensuring that the updates have been made. Ignore this message if updates have already been completed.";

    if (isExpired(eachMem.passportExpiry)) {
      errorMessage =
        "Passport expired. Please raise an Ask HR Ticket and share your passport details to HR for update on SAP. Please proceed with booking after ensuring that the updates have been made. Ignore this message if updates have already been completed.";
    }
    return errorMessage;
  });

  return sapErrorArr;
};

export const getIsDisclaimer = (sapErrorArr) => {
  let isError = false;
  sapErrorArr?.map((eachErr) => {
    if (eachErr !== "") {
      isError = true;
    }
  });
  return isError;
};

export const getBookingStatusLabel = (key) => {
  let label = BOOKING_STATUS[key] ? BOOKING_STATUS[key] : key?.toUpperCase();
  return label;
};

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return !!urlPattern.test(urlString);
};

export const convertLinks = (input, hyperLinkText) => {
  let text = input;
  const linksFound = text.match(/(?:www|https?)[^\s]+/g);
  const aLink = [];

  if (linksFound != null) {
    for (let i = 0; i < linksFound.length; i++) {
      let replace = linksFound[i];
      if (!linksFound[i].match(/(http(s?)):\/\//)) {
        replace = "http://" + linksFound[i];
      }
      let linkText = replace.split("/")[2];
      if (linkText.substring(0, 3) === "www") {
        linkText = linkText.replace("www.", "");
      }
      aLink.push(
        '<a href="' + replace + '" target="_blank">' + hyperLinkText + "</a>"
      );
      text = text
        .split(linksFound[i])
        .map((item) => {
          return aLink[i].includes("iframe") ? item.trim() : item;
        })
        .join(aLink[i]);
    }
    return text;
  } else {
    return input;
  }
};
